// import { API } from "aws-amplify";
import axios from "axios";

const ravenAPI =
  "https://vmqfftw8t1.execute-api.ca-central-1.amazonaws.com/prod";
const headers = {
  response: true,
  headers: { "Content-Type": "application/json" },
};

export function contact(email, firstName, lastName, heard, status, more) {
  return axios.post(
    `${ravenAPI}/contact`,
    {
      email: email,
      firstName: firstName,
      lastName: lastName,
      heard: heard,
      status: status,
      more: more,
    },
    headers
  );
}

export function accessCode(email, code) {
  // return API.get(clientsAPI, "/access-code", {
  //   ...headers,
  //   queryStringParameters: {
  //     email,
  //     "access-code": code,
  //   },
  // });
  return new Promise();
}

export function quotes() {
  // return API.get(quotesAPI, "/quotes", {
  //   ...headers,
  // });
  return new Promise();
}

export function getCountries() {
  return axios.get("https://restcountries.com/v3.1/all?fields=name,cca2");
}
